import { z } from 'zod';

export const taskSchema = z.object({
  title: z.string().min(1, 'Task title is required'),
  description: z.string().optional(),
  priority: z.enum(['low', 'medium', 'high']).default('medium'),
  start_date: z.string().optional(),
  end_date: z.string().optional(),
  assignee_id: z.string().uuid().optional()
});

export type TaskFormData = z.infer<typeof taskSchema>;